import BaseApi from './BaseApi'

export default class DriversApi extends BaseApi {
    async getDrivers (params = {
        name: null,
        phoneNumber: null,
        organizationId: null,
        fleetId: null,
        userId: null,
        page: null,
        perPage: null,
        orderBy: null
    }) {
        const request = new URLSearchParams()

        if (params.name) {
            request.append('Name', `%${params.name}%`)
        }

        if (params.phoneNumber) {
            request.append('PhoneNumber', `%${params.phoneNumber}%`)
        }

        if (params.organizationId) {
            request.append('OrganizationId', params.organizationId)
        }

        if (params.fleetId) {
            request.append('FleetId', params.fleetId)
        }

        if (params.userId) {
            request.append('UserId', params.userId)
        }

        if (params.page && params.perPage) {
            const skip = (params.page - 1) * params.perPage
            request.append('Skip', skip.toString())
            request.append('Take', params.perPage)
        }

        if (params.orderBy) {
            request.append('OrderBy', params.orderBy)
        }

        return this.get('/api/v1.0/drivers', request)
    }
    async getDriver (id) {
        return this.get(`/api/v1.0/drivers/${id}`)
    }
    async createDriver (params = {
        name: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        organizationId: null,
        fleetId: null,
        userId: null
    }) {
        return this.post('/api/v1.0/drivers', params)
    }
    async editDriver (params = {
        id: null,
        name: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        organizationId: null,
        fleetId: null,
        userId: null
    }) {
        return this.put('/api/v1.0/drivers', params)
    }
    async deleteDriver (id) {
        return this.delete(`/api/v1.0/drivers/${id}`)
    }
    async assignDriverToVehicle (driverId, vehicleId) {
        return this.put(`/api/v1.0/drivers/assignVehicle`, {
            driverId,
            vehicleId
        })
    }
    async unassignDriverFromVehicle (driverId) {
        return this.put(`/api/v1.0/drivers/unassignVehicle`, {
            driverId
        })
    }
}
